import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      title={lang === "en" ? "Passer en français" : "Switch to English"}
      className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-xs font-bold bg-secondary hover:bg-accent transition-colors ${className}`}
    >
      <Languages className="h-4 w-4" />
      <span className={`px-1.5 py-0.5 rounded-full transition-colors ${lang === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>EN</span>
      <span className={`px-1.5 py-0.5 rounded-full transition-colors ${lang === "fr" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>FR</span>
    </button>
  );
}
